



































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Flashcard from './Flashcard.vue';

import { firebase } from '@firebase/app';
import '@firebase/firestore'

@Component({
    components: {
        Flashcard,
    },
})
export default class Game extends Vue {
    @Prop() private cards!: any;
    @Prop() private basedir!: string;
    @Prop() private title!: string;
    private done: boolean = false;
    private ribbon: boolean = true;
    //@ts-ignore
    private card_status = {};

    private current_card: number = 0;
    private next_card: number = 1;

    columns(): any {
        return [
            {
                title: 'Things you learned',
                id: 'learned',
            },
            {
                title: 'Things you knew',
                id: 'knew',
            },
            {
                title: '"That\'s confusing"',
                id: 'confusing',
            },
        ]
    }

    indexed_cards() { 
        var all_cards = [];
        for (let [index, card] of this.cards.entries()) {
            all_cards.push({
                name: card,
                index: index,
            });
        }
        return all_cards;
    }
    
    start() {
        this.ribbon = false;
    }

    button(result: string): any {
        this.metrics(result);
        //@ts-ignore
        this.card_status[this.current_card] = result;
        this.next();
    }

    should_display(index: number): boolean {
        return (index == this.current_card) || index == this.next_card;
    }

    next(): any {
        if (this.current_card >= this.cards.length-1) {
            this.done = true;
        } else {
            this.current_card++;
        }
        if (this.current_card < this.cards.length - 1) {
            this.next_card = this.current_card + 1;
        } else {
            this.next_card = -1;
        }
    }

    async created() {
        this.firebase()
        if (!localStorage.getItem('uuid')) {
            localStorage.setItem('uuid', this.uuidv4());
        }
        // @ts-ignore
        Vue.prototype.$uuid = localStorage.getItem('uuid');
        // @ts-ignore
        this.$firedb.collection("container-flashcards").doc(this.doc()).set({
            start_timestamp: Math.floor(Date.now() / 1000),
            game_id: this.basedir,
        });

        //@ts-ignore
    }

    // metrics stuff after this
    uuidv4() {
        // @ts-ignore
        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, (c: any) =>
            // @ts-ignore
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

    doc(): any {
        // @ts-ignore
        return this.$uuid + '--' + this.basedir
    }


    firebase() {
        // Your web app's Firebase configuration
        var firebaseConfig = {
            apiKey: "AIzaSyCEbH_2zf9dDzh6Muq-DdK3byHMUIsHfCA",
            authDomain: "wizard-sql-school.firebaseapp.com",
            databaseURL: "https://wizard-sql-school.firebaseio.com",
            projectId: "wizard-sql-school",
            storageBucket: "",
            messagingSenderId: "779622015462",
            appId: "1:779622015462:web:b0ca93a1d5fbb1ea2d3627"
        };
        firebase.initializeApp(firebaseConfig);
        // @ts-ignore
        Vue.prototype.$firedb = firebase.firestore();
    }

    metrics(label: string): any {
        let update: any = {}
        update[this.cards[this.current_card]] = label;
        update['timestamp'] = Math.floor((new Date()).getTime() / 1000);
        // @ts-ignore
        this.$firedb.collection("container-flashcards").doc(this.doc()).update(update)
    }


}
